export default __webpack_public_path__ + "static/media/chevron-down.4a037df7.svg";